import React, { Component } from "react";
import { Map, TileLayer, ZoomControl, Marker, Popup } from "react-leaflet";
import { BoxZoomControl } from "react-leaflet-box-zoom";
import L from "leaflet";
import { loadEpreuves } from "../requests";
import { Link } from "react-router-dom";
import "leaflet/dist/leaflet.css";

const iconTriathlon = new L.Icon({
  iconUrl: require("../medias/pin-triathlon-map.png"),
  iconRetinaUrl: require("../medias/pin-triathlon-map.png"),
  iconAnchor: null,
  popupAnchor: [0, -18],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
  tooltipAnchor: null,
  iconSize: new L.Point(30, 40),
  className: "triathlonMarker",
});

export function coord(value) {
  const card = value.split("(").pop().split(")")[0];
  const lat = Number(card.split(",")[0]);
  const lng = Number(card.split(",")[1]);
  return [lat, lng];
}

class MapLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: props.coord || [47, 2.3488],
      popup: props.popup,
      epreuves: [],
      locKey: props.locKey,
      year: props.yearSelected || 2023,
      region:
        props.region && props.region === "Toute la France" ? "" : props.region,
    };
  }

  async componentDidMount() {
    const epreuves = await loadEpreuves(
      "",
      "",
      0,
      this.state.year.value ||
        Number(window.localStorage.getItem("year")) ||
        2023,
      ["XS", "S", "M", "L", "XL", "XXL"],
      "",
      0,
      25000,
      ["Piscine", "Lac", "Mer", "Rivière", "Plan d'eau", "0"],
      ["1", "0"]
    );
    this.setState({ epreuves });
  }

  render() {
    const { epreuves, markers, year } = this.state;
    const { zoomSize } = this.props;
    return (
      <div className="map p-0">
        <Map
          center={markers}
          zoom={zoomSize || 12}
          maxZoom={18}
          zoomControl={false}
          style={{
            position: "relative",
            top: 0,
            left: 0,
            height: "25rem",
            width: "25rem",
            //zIndex: "1",
          }}
        >
          <TileLayer
            attribution=""
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {this.state.epreuves.map((epreuve) => (
            <span key={epreuve.id}>
              {epreuve.map_coord && (
                <Marker
                  position={coord(epreuve.map_coord)}
                  icon={iconTriathlon}
                  key={epreuve.id}
                  openOn={true}
                >
                  <Popup
                    key={`popup-${epreuve.id}`}
                    position={coord(epreuve.map_coord)}
                    className="p-0"
                  >
                    <Link
                      to={`/epreuve/${epreuve.id}`}
                      className="text-warning"
                    >
                      <span className="font-weight-bold">
                        {epreuve.name_event}
                      </span>
                    </Link>
                    <br />
                    <span className="text-muted">
                      {epreuve.date.slice(0, 10) + " : "}
                      {epreuve.races.map((item) => item.type_triathlon + " ")}
                    </span>
                  </Popup>
                </Marker>
              )}
            </span>
          ))}
          <ZoomControl position="topright" />
          <BoxZoomControl position="bottomleft" sticky={true} />
        </Map>
      </div>
    );
  }
}

export default MapLocation;

// addMarker = () => {
//   const { lat, lng } = this.state;
//   console.log("coordonnées", lat, lng);
//   const { markers } = this.state;
//   markers.push([[lat, lng]]);
//   this.setState({ markers });
// };
